<template>
  <tr class="skeleton-row">
    <td v-for="n in columns" :key="n" class="skeleton-cell">
      <div class="skeleton-line"></div>
    </td>
  </tr>
</template>

<script setup>
defineProps({
  columns: {
    type: Number,
    default: 5
  }
});
</script>

<style scoped>
.skeleton-row {
  background: rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.skeleton-row::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 184, 28, 0.08),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.skeleton-cell {
  padding: 12px;
}

.skeleton-line {
  height: 16px;
  background: rgba(255, 184, 28, 0.2);
  border-radius: 4px;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Vary the widths for more realistic skeleton */
.skeleton-cell:nth-child(1) .skeleton-line {
  width: 40px; /* Rank */
}

.skeleton-cell:nth-child(2) .skeleton-line {
  width: 80%; /* Name */
}

.skeleton-cell:nth-child(3) .skeleton-line {
  width: 60px; /* Points */
}

.skeleton-cell:nth-child(4) .skeleton-line {
  width: 50px; /* W/L */
}

.skeleton-cell:nth-child(5) .skeleton-line {
  width: 50px; /* Weeks */
}
</style>
